import React, { useState } from "react";
import * as S from "./styles.ts";
import Input from "../Inputs/Input/index.tsx";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { validationConvenioSchema } from "../../schemas/validationSchema.ts";
import { Convenio } from "../../models/Convenio.ts";
import { Response } from "../../types/Api.ts";
import convenioService from "../../services/convenioService.ts";
import { InputMaskEnum } from "../../enums/InputMask.ts";
import { useFeedback } from "../../contexts/FeedbackContext.tsx";
import Loading from "../Loading/index.tsx";
import { useNavigate } from "react-router-dom";

interface CadastroConvenioProps {
  onAdd?: (response: Response<Convenio>) => void;
}

const CadastroConvenio = ({ onAdd }: CadastroConvenioProps) => {
  const { showFeedback } = useFeedback();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationConvenioSchema),
  });

  const createConvenio = (data: any) => {
    return new Convenio(0, data.nome, data.cnpj);
  };

  const onSubmit = async (data: any) => {
    const convenio: Convenio = createConvenio(data);
    setIsLoading(true);
    try {
      const response: Response<Convenio> = await convenioService.create(
        convenio
      );
      showFeedback("Convênio cadastrado com sucesso!", "success");
      if (onAdd) {
        onAdd(response);
      } else {
        navigate("/convenio/listagem");
      }
    } catch (error) {
      showFeedback(error.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <S.Form onSubmit={(e) => { e.stopPropagation(); handleSubmit(onSubmit)(e); }}>
      <S.InputGroup>
        <Input
          label="Nome*"
          variant="outlined"
          register={register("nome")}
          error={errors.nome}
          helperText={errors.nome?.message}
          style={{
            minWidth: "300px",
            width: "auto",
            display: "flex",
            flex: "1 1 auto",
          }}
        />
        <Input
          label="CNPJ*"
          variant="outlined"
          register={register("cnpj")}
          error={errors.cnpj}
          helperText={errors.cnpj?.message}
          format={InputMaskEnum.CNPJ}
          style={{
            minWidth: "300px",
            width: "auto",
            display: "flex",
            flex: "1 1 auto",
          }}
        />
        <S.SubmitButton
          variant="contained"
          color="primary"
          type="submit"
          onClick={() => {}}
        >
          {isLoading ? <Loading color="white" /> : "Cadastrar"}
        </S.SubmitButton>
      </S.InputGroup>


    </S.Form>
  );
};

export default CadastroConvenio;
